import { useAtom, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { demoIdAtom, demoResponseAtom } from './demo.atoms'
import { useMemo } from 'react'
import { doAdminMutation, reinstateDemos } from '../providers/mutations'
import { IDemoUpdate } from 'infrastructure/api'
import { makeKiddomPostRequest } from 'infrastructure/api'

function updateDemoDuration(demoId: number, tokenDurationDays: number) {
  return doAdminMutation(
    {
      key: 'updateDemoDuration',
    },
    {
      id: demoId,
      token_duration_days: tokenDurationDays,
    },
  )
}

export function useDemoResource(demoId: number | string) {
  const id = Number(demoId)
  useSetAtom(demoIdAtom)(id)
  const [atomData, reFetchDemo] = useAtom(demoResponseAtom)
  return useMemo(() => {
    return {
      data: atomData,
      reFetchDemo,
      updateDemoDuration: async (durationDays: number) => {
        await updateDemoDuration(id, durationDays)
        reFetchDemo()
      },
      reinstate: async () => {
        await reinstateDemos({ demo_ids: [id] })
        reFetchDemo()
      },
      update: async (req: IDemoUpdate) => {
        const res = await doAdminMutation(
          { key: 'updateDemo' },
          { demo_info: req },
        )
        // only refetch demo if the mutation was successful
        if (!res?.errors) {
          reFetchDemo()
        }
        return res
      },
    }
  }, [id, atomData, reFetchDemo])
}

export async function reverseLookup(params: { demoURL: string }) {
  return await makeKiddomPostRequest({
    kiddomPath: `/v1/kat/demo/demoURL`,
    requestBody: params,
  })
}
